import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { FuturePreviewViewModel } from "./future-preview.view-model";

@Component({
  selector: "evrideo-future-preview",
  templateUrl: "./future-preview.component.html",
  styleUrls: ["./future-preview.component.scss"],
})
export class FuturePreviewComponent implements OnInit {
  @Input()
  vm: FuturePreviewViewModel;

  constructor() {}

  ngOnInit() {}
}
